import { createSlice } from "@reduxjs/toolkit"
import { useSelector } from "react-redux";
import { featchApprovalFlow } from "./thunk";

/**
 * @interface
 */
const initialState = {
    loading: 'loading',
    entities: null,
    totalCount: 0,
    filters: {
        identifier: '',
        name: '',
        type: '',
        structureId: '',
        status: '',
        myfilter: 2
    },
    pagination: {
        page: 1,
        sizePerPage: 10
    },
}

// 
export const workflowSlice = createSlice({
    name: 'approvalflow',
    initialState,
    reducers: {
        changePagination: ( state, { payload } ) => {
            state.pagination.page = payload.page ?? 1
            state.pagination.sizePerPage = payload.sizePerPage ?? 10
        },
        setFilterBy: ( state, { payload } ) => {
            state.filters.identifier = payload.identifier ?? null
            state.filters.name = payload.name ?? null
            state.filters.user = payload.user ?? null
            state.filters.type = payload.type ?? null
            state.filters.structureId = payload.structureId ?? null
            state.filters.myfilter = payload.myfilter ?? 0
            state.filters.status = payload.status ?? null
            state.filters.startDate = payload.startDate ?? null
            state.filters.endDate = payload.endDate ?? null
        },
    },
    extraReducers: build => {
        build.addCase(featchApprovalFlow.fulfilled, (state, action) => {
            if ( state.loading === 'loading' ) {
                state.entities = action.payload.value
                state.totalCount = action.payload._count
                state.loading = 'idle'
            }
            // state.loading = action.payload._count
        }).addCase(featchApprovalFlow.pending, (state, action) => {
            if ( state.loading === 'idle' ) {
                state.loading = 'loading'
            }
        }).addCase(featchApprovalFlow.rejected, (state, action) => {
            if ( state.loading === 'loading' ) {
                state.loading = 'idle'
            }
        })
    }
})

// Export all reducer actions
export const {
    changePagination,
    setFilterBy,
} = workflowSlice.actions;

/**
 * 
 * @returns {initialState}
 */
export const useWorkflow = () => useSelector((state) => state.workflow )

// Export default reducer
export default workflowSlice.reducer